/**
* HTC on Cube
*
*
*/

var HTC = {
  init: function() {
    $(document).ready(function() {
      if (cube.ui.isMobile() ) {
        HTC.slickon();
      }

      HTC.bindResize();
    });
  },

  // 4 - resize
  bindResize: function() {
    var isMobileArray = [false, cube.ui.isMobile()],
    val = '';

    cube.event.on(
      'resize-width',
      cube.debounce(function() {
        if (cube.ui.isMobile()) {
          val = 'mobile';
        } else if (cube.ui.isTablet()) {
          val = 'tablet';
        } else {
          val = 'desktop';
        }
        isMobileArray[0] = isMobileArray[1];
        isMobileArray[1] = val;

        if (isMobileArray[0] !== isMobileArray[1]) {
          if (cube.ui.isMobile()) {
            if (!$('.itemsfloor .container-pmpv .pv').hasClass('slick-initialized')) {
              HTC.slickon();
            }

          } else {
            HTC.slickoff();
          }
        }
      }, 75)
    );
  },

  slickon: function() {
    $('.itemsfloor .container-pmpv .pv').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      slidesPerRow: 1,
      dots: true,
      focusOnSelect: true,
      prevArrow: false,
      nextArrow: false,
    });
  },

  slickoff: function() {
    $('.itemsfloor .container-pmpv .pv').slick('unslick');
  },
};

module.exports = HTC;




// WEBPACK FOOTER //
// ./src/modules-es5/pages/htc/htc.js